import mqtt from 'mqtt'
import config from '@/config'

function connectMqttBroker() {
  return mqtt.connect(config.mqttBrokerUrl)
}

export default connectMqttBroker
